module.exports = __webpack_public_path__ + "img/u-newaddress.6e963276.jpg";